import React from "react";
import ContactSection from "../PageSections/ContactSection";

export default function ContactPage () {
    return (
        <>
            <div className="sm:px-16 px-6 flex justify-center items-start pt-16 md:mt-[20px] mt-[35px]">
                <div className="xl:max-w-[1280px] w-full">
                    <ContactSection />
                </div>
            </div>
        </>
    )
}